var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"draggableEl",staticClass:"btn-box",style:({
        right: _vm.position.x + 'px',
        bottom: _vm.position.y + 'px'
    }),on:{"touchstart":_vm.startDrag}},[_c('div',{staticClass:"back-btn",on:{"click":_vm.backHome}},[_c('Icon',{attrs:{"name":"home-o"}})],1),_c('div',{staticClass:"back-btn",on:{"click":_vm.backUp}},[_c('Icon',{attrs:{"name":"revoke"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }